/**
 * Project : workspace
 * File    : ConversationListScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.chat.conversation.list

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.parmartechnologies.communication.core.conversation.viewModel.ConversationViewModel
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import component.button.DefaultButton
import component.empty.EmptyData
import component.input.SearchBar
import component.loader.AppLoader
import component.navigation.TopNavBar
import locale.localization
import navigation.AppNavigator
import navigation.route.workforce.EmployeeNavRoute
import presentation.screens.chat.conversation.component.ConversationCard
import theme.ThemeColor

/**
 * Represents the conversation list screens class.
 */

class ConversationListScreens{
    @Composable
    fun Content() {
        val authViewModel = AuthViewModel()
        val viewModel = ConversationViewModel()
        val allConversation = viewModel.allConversation.collectAsState()
        val searchQuery = viewModel.searchQuery.collectAsState()

        LaunchedEffect(key1 = Unit) {
            viewModel.retrieveForUser()
        }
        Column(modifier = Modifier.fillMaxSize()) {
            TopNavBar(title = "Chat", NavigationParam(), onBackPress = { }, onClickAdd = {
                AppNavigator.shared().navigate(EmployeeNavRoute.CREATE_CHAT)
            })
            AppLoader(viewModel)
            SearchBar(
                viewModel,
                searchQuery.value,
                "Search Conversation"
            )
//            ConversationList()
            if (allConversation.value.isEmpty()) {
                EmptyData(viewModel = viewModel){
                    viewModel.retrieveForUser()
                }
                DefaultButton(
                    localization().employee.addNewEmployee,
                    onClick = { AppNavigator.shared().navigate(EmployeeNavRoute.CREATE) })
            } else {
                Box(
                    modifier = Modifier
                        .height(50.dp)
                        .padding(start = 8.dp, end = 8.dp)
                        .background(
                            ThemeColor.shared().cardBackground,
                            shape = RoundedCornerShape(10.dp)
                        ),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = "${localization().employee.employeeTotal} ${allConversation.value.count()} Conversation",
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier
                            .wrapContentHeight().fillMaxWidth(),
                        textAlign = TextAlign.Center,
                        color = ThemeColor.shared().PrimaryColor
                    )
                }
            }
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 400.dp),
                modifier = Modifier.fillMaxSize()
            ) {
                items(count = allConversation.value.count()) { index ->
                    authViewModel.getUserDetails(allConversation.value[index]._id){

                    }
                    ConversationCard(allConversation.value[index],viewModel,authViewModel) {selectedConversation->
                        AppNavigator.shared().navigate(EmployeeNavRoute.CHAT,NavigationParam(conversation = selectedConversation))
                    }
                }
            }
        }
    }
}